module.exports = __webpack_public_path__ + "static/media/face.1d987bd2.svg";